import { Box, GridItem, SimpleGrid } from '@chakra-ui/react';
import { t } from 'i18next';
import styled from 'styled-components';
import StickyHeader from '../../components/StickyHeader';
import { useArtistQueryAll } from '../../components/api/queries/useArtistQuery';
import { ArtistCircleBox } from '../../components/artist/ArtistCircleBox';
import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';

const TitleWrapper = styled.div`
  padding-top: calc(54px + env(safe-area-inset-top));
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 12px;
`;

const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  line-height: 31px;
  text-align: left;
  white-space: pre-wrap;
`;

const ArtistsWrapper = styled.div`
  padding: 26px 24px;
`;

export const ReportSelectArtistPage = () => {
  const { queryParams, updateQueryParams } = useQueryParams();
  const reportType = queryParams.get('reportType');
  const locationId = queryParams.get('locationId');
  const artists = useArtistQueryAll();

  const onArtistSelected = (artist) => {
    const artistId = artist.artistId;
    if (locationId) {
      updateQueryParams({ artistId, reportType, locationId }, '/report/select-member');
    } else {
      updateQueryParams({ artistId, reportType }, '/report/select-member');
    }
  };

  return (
    <>
      <StickyHeader
        showBackButton={true}
        showTitle={true}
        title={t('reportPhotoCardPage.pageName')}
      />
      <TitleWrapper>
        <Title className="text-main-light-1 dark:text-main-dark-1">
          {reportType === 'photoCard'
            ? t('ReportPhotoCardSelectArtistPage.titlePhotoCard')
            : (reportType === 'location' || reportType === 'footprint')
              ? t('ReportPhotoCardSelectArtistPage.titleLocation')
              : t('ReportPhotoCardSelectArtistPage.title')}
        </Title>
      </TitleWrapper>
      <ArtistsWrapper>
        <SimpleGrid columns={2} spacingX={'18px'} spacingY={'26px'}>
          {artists
            ?.filter((a) => !!a.likedDate)
            .map((artist) => {
              return (
                <GridItem rowSpan={1} key={artist.name}>
                  <Box>
                    <ArtistCircleBox
                      artist={artist}
                      onArtistSelected={(artist) => onArtistSelected(artist)}
                    />
                  </Box>
                </GridItem>
              );
            })}
        </SimpleGrid>
      </ArtistsWrapper>
    </>
  );
};
